/* eslint-disable react/prop-types */
/* eslint-disable react/display-name */
import React, { FC } from 'react'
import { NumericTextBox } from '@progress/kendo-react-inputs'
import {
  Card,
  CardBody,
  GridLayout,
  GridLayoutItem
} from '@progress/kendo-react-layout'
import { Label } from '@progress/kendo-react-labels'
import { SimulationCalculationInfoResItem } from '@gateway.Simulation'

export interface ExpenseInformationProps {
  workYamadumi: SimulationCalculationInfoResItem
  isReadonlyDisabled: boolean
  onChange: (id: string, value: number | null) => void
}
export const ExpenseInformationAppropriateTypeC: FC<ExpenseInformationProps> = React.memo(({
  workYamadumi,
  isReadonlyDisabled,
  onChange
}) => {
  return (
    <Card>
      <CardBody>
        <GridLayout gap={{ cols: 10 }}>
          <GridLayoutItem col={3}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>労務数量（{workYamadumi.unit2}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>全体</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityAll ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityAll', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>その他</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityOther ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityOther', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={4} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={4} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.constructionQuantityFinish ?? undefined}
                  onChange={
                    (event) => onChange('constructionQuantityFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={4}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>工期（ヶ月）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>その他</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleOther ?? undefined}
                  onChange={
                    (event) => onChange('scheduleOther', event.value)
                  }
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0, useGrouping: false }}
                  value={workYamadumi?.scheduleFinish ?? undefined}
                  onChange={
                    (event) => onChange('scheduleFinish', event.value)
                  }
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
          <GridLayoutItem col={5}>
            <GridLayout
              gap={{ cols: 10 }}
              rows={[
                { height: '2.0em' },
                { height: '1.5em' },
                { height: '1.5em' }
              ]}
            >
              <GridLayoutItem row={1} col={1} colSpan={2}>
                <Label>予定({workYamadumi.unit5})数（{workYamadumi.unit4}）</Label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={1}>
                <label>その他</label>
              </GridLayoutItem>
              <GridLayoutItem row={2} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  value={workYamadumi?.scheduledWorkOther ?? undefined}
                  onChange={(event) => onChange('scheduledWorkOther', event.value)}
                />
              </GridLayoutItem>
              <GridLayoutItem row={3} col={1}>
                <label>仕上げ</label>
              </GridLayoutItem>
              <GridLayoutItem row={3} col={2}>
                <NumericTextBox
                  disabled={isReadonlyDisabled}
                  style={{ width: '150px', height: '20px' }}
                  spinners={false}
                  format={{ maximumFractionDigits: 0 }}
                  value={workYamadumi?.scheduledWorkFinish ?? undefined}
                  onChange={(event) => onChange('scheduledWorkFinish', event.value)}
                />
              </GridLayoutItem>
            </GridLayout>
          </GridLayoutItem>
        </GridLayout>
      </CardBody>
    </Card>
  )
})
